import { axiosWrapper } from '../requestHandler/axiosWrapper';
import { authTokenManager } from '../requestHandler/authTokenManager';

var BACK_URL = process.env.VUE_APP_BACK_URL;
if(BACK_URL === undefined){
  BACK_URL = "http://localhost:8080";
}

export const authService = {
  async register(userData) {
    try {
      const response = await axiosWrapper.post(BACK_URL + '/auth/register', userData);
      return response.data;
    } catch (error) {
      console.error('Registration failed:', error);
      throw error;
    }
  },

  async registerGuest(userData) {
    try {
      const response = await axiosWrapper.post(BACK_URL + '/auth/register-guest', userData);
      return response.data;
    } catch (error) {
      console.error('Guest registration failed:', error);
      throw error;
    }
  },

  async login(email, password) {
    try {
      const response = await axiosWrapper.post(BACK_URL + '/auth/login', { email, password });
      const { access_token, refresh_token } = response.data;

      await authTokenManager.setAccessToken(access_token);
      await authTokenManager.setRefreshToken(refresh_token);

      return response.data;

    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  },
  async me() {
    try {
      const response = await axiosWrapper.get(BACK_URL + '/auth/me');
      return response.data;
    } catch (error) {
      console.error('Failed to get user data:', error);
      throw error;
    }
  },
  async verifyUser(access_token)
  {
    try {
      await authTokenManager.setAccessToken(access_token);
      const response = await axiosWrapper.get(BACK_URL + '/auth/user/verify');
      authTokenManager.clear();
      return response.data;
    } catch (error) {
      console.error('Failed to verify user:', error);
      throw error;
    }
  },
  async forgotPassword(email) {
    try {
      email = encodeURIComponent(email);
      const response = await axiosWrapper.get(BACK_URL + '/auth/forgot-password?email='+email);
      return response.data;
    } catch (error) {
      console.error('Failed to send password reset email:', error);
      throw error;
    }
  },

  async resetPassword(token, password) {
    try {
      await authTokenManager.setAccessToken(token);
      const response = await axiosWrapper.post(BACK_URL + '/auth/reset-password', { password });
      authTokenManager.clear();
      return response.data;
    } catch (error) {
      console.error('Failed to reset password:', error);
      throw error;
    }
  },

};